module.exports = __webpack_public_path__ + "static/media/4.d114ea2a.JPG";